/* eslint-disable no-mixed-spaces-and-tabs */
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { requestShiftAction } from "../../../../../../export/shift-swaps";
import Button from "../../../../../design/button";
import LoadingButton from "../../../../../design/wilya-loading-button";
import useSchedulerData from "../../../controllers/use-scheduler-data";

type ApproveProps = {
  handleClose: (() => void) | undefined;
  toDecline?: boolean;
  isPending?: boolean;
};

const Approve: React.FC<ApproveProps> = ({ handleClose, toDecline = false, isPending = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isRejecting, setIsRejecting] = useState(false);
  const {
    createDraftShiftAsyncErrorMessage,
    requestActionStatus,
    requestActionErrorMessage,
    formData,
    userRoles,
  } = useSchedulerData();

  const handleSubmit = () => {
    setIsRejecting(false);
    const payload = {
      ...formData,
      decisionCode: "a",
      flexShiftDetails: null,
    };
    dispatch(requestShiftAction(payload));
  };

  const handleReject = () => {
    setIsRejecting(true);
    const payload = {
      ...formData,
      decisionCode: "r",
      flexShiftDetails: null,
    };
    dispatch(requestShiftAction(payload));
  };

  const isRejectLoading = isRejecting && requestActionStatus === "pending";
  const isApproveLoading = !isRejecting && requestActionStatus === "pending";

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="flex-end"
      alignItems="center"
    >
      {requestActionErrorMessage ? (
        <Typography color="secondary">
          {requestActionErrorMessage as string}
        </Typography>
      ) : null}
      <Box ml={2} display="flex" justifyContent="flex-end" alignItems="center">
        <Button color="primary" variant="text" onClick={handleClose}>
          {t("common_cancel")}
        </Button>
        {(toDecline || isPending) && (
          <LoadingButton
            variant="outlined"
            sx={{
              marginLeft: "16px",
              color: "#d32f2f",
              borderColor: "#d32f2f",
              "&:hover": {
                borderColor: "#d32f2f",
                backgroundColor: "rgba(211, 47, 47, 0.04)",
              },
            }}
            loading={isRejectLoading}
            onClick={handleReject}
            loadingIndicator={
              <CircularProgress size={16} sx={{ color: "#d32f2f" }} />
            }
            disabled={requestActionStatus === "pending"}
          >
            {t("scheduler_decline")}
          </LoadingButton>
        )}
        {(!toDecline || isPending) && (
          <LoadingButton
            variant="contained"
            sx={{ marginLeft: "16px" }}
            loading={isApproveLoading}
            onClick={handleSubmit}
            loadingIndicator={
              <CircularProgress
                size={16}
                sx={{ color: "rgba(0, 0, 0, 0.38)" }}
              />
            }
            disabled={requestActionStatus === "pending"}
          >
            {t("scheduler_approve")}
          </LoadingButton>
        )}
      </Box>
    </Box>
  );
};

export default Approve;
